import React from 'react';
import { IMAGES } from '../data/content';
import { Section, Reveal, Eyebrow } from './Section';
export function WhyMedufit() {
  return <Section id="why" className="py-16 md:py-20" data-id="element-308" data-mp="1ripberfvu9tn">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-309" data-mp="267v7i6jfbjxb">
        <Reveal className="order-2 lg:order-1" data-id="element-310" data-mp="269xwqocr590z">
          <Eyebrow data-id="element-311" data-mp="21a38yto9wzk5">Why Medufit Exists</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-forest sm:text-4xl lg:text-[2.75rem]" data-id="element-312" data-mp="21beasny5rx8m">
            We don’t believe wellness should be complicated.
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-forest/70" data-id="element-313" data-mp="18mpi9db6508h">
            <p data-id="element-314" data-mp="1mlgu0t2k69tg">
              Most people juggle multiple supplements every day. Different vitamins. Different
              minerals. Different herbal products. It’s a lot to keep up with — so most of us
              eventually stop.
            </p>
            <p className="text-forest/80" data-id="element-315" data-mp="2ty8w1n2sv0n5">
              Medufit combines everything into one simple daily ritual.
            </p>
          </div>

          <div className="mt-8 flex items-center gap-3" data-id="element-316" data-mp="3qmu6s0fb6dsa">
            {['Mix', 'Drink', 'Go'].map((word, i) => <React.Fragment key={word} data-id="element-317" data-mp="3vo1cltxw52wb" data-mpi={i}>
                <span className="font-serif text-2xl italic text-forest sm:text-3xl" data-id="element-318" data-mp="3i5wvonhqz78">{word}.</span>
                {i < 2 && <span className="h-1.5 w-1.5 rounded-full bg-sage" data-id="element-319" data-mp="8gfsu1h1i3tw" />}
              </React.Fragment>)}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="order-1 lg:order-2" data-id="element-320" data-mp="37uszc9ogxf79">
          <div className="overflow-hidden rounded-[2rem] border border-forest/10 shadow-xl" data-id="element-321" data-mp="3bz0qedief78n">
            <img src={IMAGES.why} alt="A calm morning breakfast nook with a glass of Medufit and fresh amla in natural light" className="h-full w-full object-cover" data-id="element-322" data-mp="3gwip7b2pc62x" />
          </div>
        </Reveal>
      </div>
    </Section>;
}